var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-left"},[_c('a',{staticClass:"logo",attrs:{"href":("" + _vm.url)}},[_vm._v("CEWS Manager")])]),(_vm.auth)?_c('NavigationRight'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }